import React from "react";
import { Layout, Typography, Row, Col, Card, Button } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";

const { Content } = Layout;
const { Title, Paragraph } = Typography;

const benefits = [
  {
    title: "Industry-Recognized Certification",
    description: "Earn a certification that validates your AI, Cybersecurity, and Data Science expertise.",
  },
  {
    title: "Real-World Skill Assessment",
    description: "Get assessed on practical challenges designed by industry experts.",
  },
  {
    title: "Enhanced Career Opportunities",
    description: "Showcase your JectHub certification to top recruiters and tech companies.",
  },
  {
    title: "Networking & Collaboration",
    description: "Join an elite group of certified professionals and grow your connections.",
  },
];

const QualifiedByJectHub = () => {
  return (
    <Layout>
      <Content style={{ padding: "50px", background: "#f0f2f5", textAlign: "center" }}>
        <Title level={2} style={{ fontSize: "24px", color: "#1890ff" }}>
          Qualified by JectHub
        </Title>
        <Paragraph style={{ fontSize: "16px", color: "#666", marginBottom: "30px" }}>
          Stand out in the tech industry with a JectHub certification. Gain credibility, enhance your skills,
          and unlock new career opportunities in AI, Cybersecurity, and Data Science.
        </Paragraph>

        <Row gutter={[16, 16]} justify="center">
          {benefits.map((benefit, index) => (
            <Col xs={24} sm={12} md={6} lg={6} key={index}>
              <Card
                hoverable
                style={{
                  borderRadius: "8px",
                  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  padding: "16px",
                }}
              >
                <CheckCircleOutlined style={{ fontSize: "40px", color: "#1890ff", marginBottom: "16px" }} />
                <Title level={4} style={{ color: "#333", marginBottom: "12px" }}>
                  {benefit.title}
                </Title>
                <Paragraph style={{ color: "#666", fontSize: "14px" }}>
                  {benefit.description}
                </Paragraph>
              </Card>
            </Col>
          ))}
        </Row>

        <Button
          type="primary"
          size="large"
          href="/signin"
          style={{ marginTop: "40px", backgroundColor: "#1890ff", borderColor: "#1890ff" }}
        >
          Get Certified Now
        </Button>
      </Content>
    </Layout>
  );
};

export default QualifiedByJectHub;